export const TIME_AGGREGATION = [
  'second',
  'minute',
  'hour',
  'day',
  'week',
  'month',
  'year',
] as const;

export type TimeAggregation = (typeof TIME_AGGREGATION)[number];
